import {
  FeatureAppTrackingEvent,
  FeatureAppTrackingManager,
  getDefaultTrackingEvent,
} from '../hooks/use-tracking-manager';
import _ from 'lodash';

export interface Content {
  ItemCount?: number;
  ItemPosition?: number;
  CountdownTotalTime?: number;
  CountdownRemainingTime?: number;
  RSSFeedsCount?: number;
}

export interface Link {
  name?: string;
  url?: string;
  newTab?: boolean;
}

/**
 * handle vw basic link click
 * @param trackingManager
 * @param contentData
 * @param link
 */
export const onVWBasicLinkClickEvent = (
  linkData?: Link,
  contentData?: Content,
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VWBasic_Link_Click',
      customEvent,
    );
};

export const onVWVideoPlayerVideoSelect = (
  linkData?: Link,
  contentData?: Content,
  videoInfo?: FeatureAppTrackingEvent['video'],
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.video = videoInfo;

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VideoPlayer_Video_SelectClick',
      customEvent,
    );
};

export const onVWVideoPlayerStart = (
  linkData?: Link,
  contentData?: Content,
  videoInfo?: FeatureAppTrackingEvent['video'],
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.video = videoInfo;

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VideoPlayer_Video_Start',
      customEvent,
    );
};

export const onVWVideoPlayClickEvent = (
  linkData?: Link,
  contentData?: Content,
  videoInfo?: FeatureAppTrackingEvent['video'],
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.video = videoInfo;

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VideoPlayer_VideoPlay_Click',
      customEvent,
    );
};

export const onVWVideoPauseClickEvent = (
  linkData?: Link,
  contentData?: Content,
  videoInfo?: FeatureAppTrackingEvent['video'],
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.video = videoInfo;

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VideoPlayer_VideoPause_Click',
      customEvent,
    );
};

export const onVWVideoMilestoneReachedEvent = (
  linkData?: Link,
  contentData?: Content,
  videoInfo?: FeatureAppTrackingEvent['video'],
  trackingManager?: FeatureAppTrackingManager,
) => {
  if (!trackingManager) return;

  let customEvent = getDefaultTrackingEvent();
  customEvent.link = linkData;
  customEvent.content = contentData;
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.eventInfo = { ...customEvent.eventInfo };
  customEvent.video = videoInfo;

  trackingManager &&
    trackingManager.trackFeatureAppGlobalEvent(
      'VideoPlayer_VideoMilestone_Reached',
      customEvent,
    );
};
